
import Vue from "vue";
import { mapState } from "vuex";
import store from "@/store";
import EventBus from "@/utils/EventBus";

interface LinkDef {
  text: string;
  icon: string;
  to: string;
  onlyUser?: boolean;
  visibleRoles?: string[];
}

// eslint-disable-next-line
const Navigation: any = Vue.extend({
  name: "MyNavigation",
  computed: {
    ...mapState("user", ["users"]),
    ...mapState("auth", ["currentUser"]),
  },
  data: () => ({
    drawer: false,
    adminListActive: true,
    isAdmin: store.state.auth.isAdmin,
    isProjectManager: store.state.auth.isProjectManager,
    isUser: store.state.auth.isUser,
  }),
  async mounted() {
    EventBus.$on("toggleDrawer", this.toggleDrawer);
  },
  beforeDestroy() {
    EventBus.$off("toggleDrawer");
  },
  methods: {
    items(): LinkDef[] {
      return [
        {
          text: "Kontakte",
          icon: "mdi-account-multiple",
          to: "/contacts",
          onlyUser: false,
        },
        {
          text: "E-Mails",
          icon: "mdi-email-multiple",
          to: "/emails",
          onlyUser: false,
        },
        {
          text: "Sprachnotizen",
          icon: "mdi-microphone-message",
          to: "/voicenotes",
          onlyUser: true,
        },
        { text: "Flammen", icon: "mdi-fire", to: "/flames", onlyUser: true },
        {
          text: "Meine Flammen",
          icon: "mdi-campfire",
          to: "/ownDueFlames",
          onlyUser: true,
        },
        {
          text: "Meine Projekte",
          icon: "mdi-lightbulb-on",
          to: "/ownDueProjects",
          onlyUser: true,
        },
        {
          text: "Meine Aufgaben",
          icon: "mdi-format-list-checks",
          to: "/ownToDos",
          onlyUser: true,
        },
        {
          text: "Projekte",
          icon: "mdi-lightbulb-on",
          to: "/projects",
          onlyUser: true,
        },
        {
          text: "Abholkalender",
          icon: "mdi-calendar",
          to: "/pickupcalendar",
          onlyUser: false,
        },
        {
          text: "Gesprächstermine",
          icon: "mdi-calendar-range",
          to: "/appointmentcalendar",
          onlyUser: false,
        },
      ].filter((item) => item.onlyUser == this.isUser || !item.onlyUser);
    },
    adminItems(): LinkDef[] {
      return [
        {
          text: "Alle offenen Flammen",
          icon: "mdi-fire",
          to: "/allOpenFlames",
          visibleRoles: ["ADMIN"],
        },
        {
          text: "Alle archivierten Flammen",
          icon: "mdi-fire",
          to: "/allArchivedFlames",
          visibleRoles: ["ADMIN"],
        },
        {
          text: "Alle archivierten Projekte",
          icon: "mdi-lightbulb-on",
          to: "/allArchivedProjects",
          visibleRoles: ["ADMIN", "PROJECT_MANAGER"],
        },
        {
          text: "Alle offene Aufgaben",
          icon: "mdi-format-list-checks",
          to: "/allOpenTodos",
          visibleRoles: ["ADMIN"],
        },
        //{text: 'Dubletten-Check', icon: 'mdi-account-group', to: '/duplicateContacts', visibleRoles: ["ADMIN"]},
        {
          text: "Benutzerverwaltung",
          icon: "mdi-shield-account",
          to: "/users",
          visibleRoles: ["ADMIN"],
        },
        //{text: 'Postfächer', icon: 'mdi-mailbox', to: '/mailboxes', visibleRoles: ["ADMIN"]},
        //{text: 'Kontakte importieren', icon: 'mdi-microsoft-outlook', to: '/csvImport', visibleRoles: ["ADMIN"]},
        //{text: 'Produkte & Zubehör', icon: 'mdi-tag', to: '/products', visibleRoles: ["ADMIN"]},
        //{text: 'Blackboard', icon: 'mdi-clipboard-text-multiple-outline', to: '/blackboards', visibleRoles: ["ADMIN"]},
        //{text: 'Lieferkonditionen', icon: 'mdi-truck-delivery', to: '/deliveryConditions', visibleRoles: ["ADMIN"]},
        //{text: 'Zahlungskonditionen', icon: 'mdi-credit-card', to: '/paymentConditions', visibleRoles: ["ADMIN"]},
        //{text: 'Branchen', icon: 'mdi-domain', to: '/sectors', visibleRoles: ["ADMIN"]},
        //{text: 'Spedition', icon: 'mdi-truck', to: '/forward-agency', visibleRoles: ["ADMIN"]},
        //{text: 'Lager', icon: 'mdi-warehouse', to: '/warehouses', visibleRoles: ["ADMIN"]},
        //{text: 'Vorlagen', icon: 'mdi-text-box-outline', to: '/templates', visibleRoles: ["ADMIN"]},
        //{text: 'Zeitslots', icon: 'mdi-calendar-range', to: '/predefinedTimeSlots', visibleRoles: ["ADMIN"]},
        {
          text: "Abwesenheitnotiz E-Mail",
          icon: "mdi-alarm-note",
          to: "/absenceEmail",
          visibleRoles: ["ADMIN", "ABWESENHEITEN"],
        },
        {
          text: "Gemeinsame Dokumente",
          icon: "mdi-file-document-multiple-outline",
          to: "/sharedDocuments",
          visibleRoles: ["ADMIN"],
        },
        {
          text: "Bilder",
          icon: "mdi-image-album",
          to: "/image-gallery",
          visibleRoles: ["ADMIN"],
        },
        {
          text: "Aufgabenpakete",
          icon: "mdi-package-variant-closed",
          to: "/todoPackages",
          visibleRoles: ["ADMIN"],
        },
        {
          text: "Mehr",
          icon: "mdi-dots-horizontal",
          to: "/more-admin-menu",
          visibleRoles: ["ADMIN"],
        },
        //{text: 'Packstücke', icon: 'mdi-shipping-pallet', to: '/pallets', visibleRoles: ["ADMIN"]},
        //{text: 'E-Mail Signatur', icon: 'mdi-signature', to: '/emailsignature', visibleRoles: ["ADMIN"]},
      ].sort((a, b) => a.text.localeCompare(b.text));
    },
    changePassword() {
      this.$emit("changePassword");
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    async logout() {
      await this.$store.dispatch("auth/resetCurrentUser");
      await this.$router.push("/login");
    },
    getCurrentUserAvatarAbbreviation(): string {
      return this.currentUser.username?.substring(0, 2) ?? "";
    },

    currentUserHasRole(roles: string[]): boolean {
      return roles.some((role) => this.currentUser.roles.includes(role));
    },
  },
});

export default Navigation;
